import classes from './update-password-section.module.scss';
import { Constants } from '../../../../../constants/constants';
import useUpdatePassword from '../../../../../Hooks/settings/update-password.hook';

import { Input, Button, Form, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

export default function UpdatePasswordSection() {
  const updatePassword = useUpdatePassword();
  const { t } = useTranslation();

  return (
    <Spin spinning={updatePassword.isLoading}>
      <Form
        name="updatePassword"
        className={classes.form}
        initialValues={{ remember: true }}
        onFinish={updatePassword.handleSubmit}
        onFinishFailed={updatePassword.handleSubmitFail}
        disabled={updatePassword.isLoading}
        layout='vertical'
      >
        <Form.Item
          label={t('settings.current-password')}
          name="currPassword"
          rules={[{ required: true, message: t('validation.current-password-required') }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label={t('settings.new-password')}
          name="newPassword"
          rules={[
            { required: true, message: t('validation.new-password-required') },
            { pattern: Constants.PASSWORD_PATTERN, message: t('common.password-rules') }
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label={t('settings.confirm-new-password')}
          name="confirm"
          dependencies={['newPassword']}
          hasFeedback
          rules={[{ required: true, message: t('validation.confirm-password-required') },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('newPassword') === value) {
                return Promise.resolve();
              }

              return Promise.reject(
                new Error(t('common.password-mismatch')),
              );
            },
          }),
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item className={classes.formItem}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={updatePassword.isLoading}
          >
            {t('settings.change-password')}
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};
